import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {darkBackgroundSemanticStyles, lightBackgroundSemanticStyles} from './backgroundSemanticStyles';
import {darkIconSemanticStyles, lightIconSemanticStyles} from './iconSemanticStyles';
import {darkTypographySemanticStyles, lightTypographySemanticStyles} from './typographySemanticStyles';

export interface ComposerSemanticStyles {
  aiAssistantComposer: {
    actionButton: {
      backgroundColor: string;
      backgroundColorHover: string;
      backgroundColorActive: string;
      backgroundColorDisabled: string;
      textColor: string;
      textColorDisabled: string;
      iconColor: string;
      iconColorDisabled: string;
    };
  };
}

export const lightComposerSemanticStyles = {
  aiAssistantComposer: {
    actionButton: {
      backgroundColor: colorPrimitive.gray['100'],
      backgroundColorHover: colorPrimitive.gray['200'],
      backgroundColorActive: colorPrimitive.gray['200'],
      backgroundColorDisabled: lightBackgroundSemanticStyles.fill.primaryDisabled,
      textColor: lightTypographySemanticStyles.shades.primary,
      textColorDisabled: lightTypographySemanticStyles.shades['on-bg-fill-disabled'],
      iconColor: lightIconSemanticStyles.primary,
      iconColorDisabled: lightIconSemanticStyles.disabled,
    },
  },
} as const satisfies ComposerSemanticStyles;

export const darkComposerSemanticStyles: ComposerSemanticStyles = {
  aiAssistantComposer: {
    actionButton: {
      backgroundColor: colorPrimitive.gray['900'],
      backgroundColorHover: colorPrimitive.gray['800'],
      backgroundColorActive: colorPrimitive.gray['700'],
      backgroundColorDisabled: darkBackgroundSemanticStyles.fill.primaryDisabled,
      textColor: darkTypographySemanticStyles.shades.primary,
      textColorDisabled: darkTypographySemanticStyles.shades['on-bg-fill-disabled'],
      iconColor: darkIconSemanticStyles.primary,
      iconColorDisabled: darkIconSemanticStyles.disabled,
    },
  },
} as const satisfies ComposerSemanticStyles;
